import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import LoginForm from './LoginForm';
import ResetPasswordForm from './ResetPasswordForm';
import CreatePasswordForm from './CreatePasswordForm';
import RidecellLogo from '../../common/assets/ridecellLogo.jpeg';
import useGlobalContext from '../../common/hooks/useGlobalContext';

import styles from './styles';

const LoginPage = (props) => {
  const { classes, match } = props;
  const startingForm = match.path.startsWith('/reset') ? 'createNewPassword' : 'login';
  const [formToDislay, setFormToDisplay] = useState(startingForm);
  const {
    state: { tenantSettings },
    setTenantSettings,
  } = useGlobalContext();

  useEffect(() => {
    axios.get('/api/v2/settings').then(({ data }) => setTenantSettings(data));
  }, []);
  let logo = RidecellLogo;

  if (tenantSettings && tenantSettings.agency_logo !== '/static/common/images/agency_logo.png') {
    logo = tenantSettings.agency_logo;
    // Store the logo url in the local storage for reload
    localStorage.setItem('agency_logo_url', logo);
  } else if (localStorage.getItem('agency_logo_url')) {
    // Get the local storage url if available to prevent image reload
    logo = localStorage.getItem('agency_logo_url');
  }

  return (
    <div className={clsx(classes.background, classes.modalPlacement)}>
      <Box className={classes.loginModal}>
        <img alt="logo" className={classes.logo} src={logo} />
        {formToDislay === 'login' && <LoginForm setFormToDisplay={setFormToDisplay} />}
        {formToDislay === 'resetPassword' && (
          <ResetPasswordForm setFormToDisplay={setFormToDisplay} />
        )}
        {formToDislay === 'createNewPassword' && (
          <CreatePasswordForm setFormToDisplay={setFormToDisplay} {...props} />
        )}
      </Box>
    </div>
  );
};

export default withStyles(styles)(LoginPage);
